import { useRouter } from 'next/router';
import { DefaultSeo, SiteLinksSearchBoxJsonLd, SocialProfileJsonLd } from 'next-seo';
import Head from 'next/head';
import Script from 'next/script';

// conf
import SEO from '../../../config/next-seo.config';

export default function MetaHeader() {
  const router = useRouter();
  const doNotDisplayAxeptio =
    router.asPath.includes('app/referral') || router.asPath.includes('app/sync');
  const axeptioCookieLocale = router.locale === 'fr' ? 'fr' : 'en';
  const axeptioCookieDomain = process.env.VERCEL_ENV === 'production' ? '.finary.com' : null;

  const axeptioSettings = {
    clientId: process.env.NEXT_PUBLIC_AXEPTIO_CLIENT_ID,
    cookiesVersion: `finary-${axeptioCookieLocale}`,
    userCookiesDomain: axeptioCookieDomain,
    userCookiesDuration: 180,
    googleConsentMode: {
      default: {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500,
      },
    },
  };

  return (
    <>
      <Script
        src="https://connect.facebook.net/en_US/sdk.js"
        strategy="lazyOnload"
        id="fbsdk"
        onLoad={() => {
          window.fbAsyncInit = function () {
            window.FB.init({
              appId: '1559993554360114',
              version: 'v3.3',
            });
          };
        }}
      />
      {!doNotDisplayAxeptio ? (
        <Script
          id="axeptio"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
              window.axeptioSettings = ${JSON.stringify(axeptioSettings)};
              (function(d, s) {
                  var t = d.getElementsByTagName(s)[0], e = d.createElement(s);
                  e.async = true; e.src = "//static.axept.io/sdk.js";
                  t.parentNode.insertBefore(e, t);
              })(document, "script");
            `,
          }}
        />
      ) : null}

      <DefaultSeo {...SEO} />
      <SiteLinksSearchBoxJsonLd
        url="https://community.finary.com"
        potentialActions={[
          {
            target: 'https://community.finary.com/search?q=',
            queryInput: 'search_term_string',
          },
        ]}
      />
      <SocialProfileJsonLd
        type="Organization"
        name="Finary"
        url="https://finary.com/"
        sameAs={[
          'https://www.facebook.com/Finary-104848758108887',
          'https://fr.linkedin.com/company/finaryhq',
        ]}
      />
      <Head>
        <meta name="apple-mobile-web-app-title" content="Finary" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="facebook-domain-verification" content="ayibyc9rs8jp1x2ivqn04p9lywjrh3" />
        <link rel="apple-touch-icon" href="/icons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/icons/favicon-16x16.png" />
        <link rel="manifest" href="/manifest.json" />
        <link rel="mask-icon" href="/icons/safari-pinned-tab.svg" color="#f1c086" />
        <link rel="icon" href="/icons/favicon.ico" />
        {/* <!-- This is Finary --> */}
      </Head>
    </>
  );
}
